import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ChakraBaseProvider } from "@chakra-ui/react";
import amplitude from "amplitude-js";
import SharePage from "./pages/SharePage";
import theme from "./theme";
import Prove from "./pages/Prove";
import Verify from "./pages/Verify";
import Verifier from "./pages/Verifier";
import Test from "./pages/test";

const App = () => {
  useEffect(() => {
    const apiKey = import.meta.env.VITE_AMPLITUDE_API_KEY || "";
    amplitude.getInstance().init(apiKey);

    amplitude.getInstance().logEvent("share reclaim website opened");

    return () => {
      amplitude.getInstance().regenerateDeviceId();
    };
  }, []);
  return (
    <ChakraBaseProvider theme={theme}>
      <main className="App">
        <Router>
          <Routes>
            <Route path="/link/:id" element={<SharePage type="link" />} />
            <Route path="/template/:id" element={<SharePage type="template" />} />
            <Route path="/selectLinks/:id" element={<SharePage type="selectLinks" />} />
            <Route path="/handshake/:id" element={<SharePage type="handshake" />} />
            <Route path="/requestedProofs/:id" element={<SharePage type="requestedProofs" />} />
            <Route path="/prove" element={<Prove />} />
            <Route path="/instant" element={<Prove />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/verifier" element={<Verifier />} />
            <Route path="/test" element={<Test />} />
            <Route path="/vana-app" element={<Verify />} />
            <Route path="/vana" element={<Verifier />} />
          </Routes>
        </Router>
      </main>
    </ChakraBaseProvider>
  );
};

export default App;
